module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_03_1280_1280_vi-e7a2393e9a2ad32d9cc24761fffce26a.jpg";